import clsx from 'clsx'
import type { ReactNode } from 'react'

export interface PanelProps {
  title?: string
  right?: ReactNode
  children: ReactNode
  className?: string
  pad?: boolean
}

export function Panel({ title, right, children, className, pad = true }: PanelProps) {
  return (
    <section
      className={clsx(
        'flex flex-col overflow-hidden rounded-[14px] border border-[rgba(15,23,42,0.07)] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]',
        className,
      )}
    >
      {title != null || right != null ? (
        <div className="flex items-center justify-between gap-2 px-4 pb-2 pt-3">
          {title != null ? (
            <span className="text-[10px] font-medium uppercase tracking-[0.12em] text-[#94A3B8]">
              {title}
            </span>
          ) : (
            <span />
          )}
          {right}
        </div>
      ) : null}
      <div className={clsx('min-h-0 flex-1', pad && 'p-4', pad && (title != null || right != null) && 'pt-0')}>
        {children}
      </div>
    </section>
  )
}
